/* eslint-disable import/prefer-default-export */
export const getUsers = (store) => Object.values(store.user)

export const getUser = (store, userId) => store.user?.[userId]
